import React from "react";
import {FieldRenderProps} from "react-final-form";
import {inputGroupStyled} from "../styles/style-config";
import cn from "classnames";

type Props<T> = FieldRenderProps<T, HTMLInputElement>;

export const InputAdapter = <T extends string>(props: Props<T>) => {
  const {value} = props.input;
  const hasError =
    (props.meta.touched && props.meta.error) || props.meta.submitError;
  const renderError = props.meta.error
    ? props.meta.error
    : props.meta.submitError;

  return (
    <div
      className={cn(inputGroupStyled, {
        required: hasError,
        filled: !!value,
      })}
    >
      {props.label && <label>{props.label}</label>}
      <input
        ref={props.ref}
        {...props.input}
        disabled={props.disabled}
        placeholder={props.placeholder}
      />
      {hasError && <p className={"error"}>{renderError}</p>}
    </div>
  );
};
